import { H3 } from '@h3/types';
import { request } from '@h3/request';

export function refreshTimeStamp(engineCode: string) {
    return request<H3.Http.Response.H3Response<void>>('/EngineWebService/RefreshTimeStamp', {
        method: H3.Http.MethodType.POST,
        data: {
            Parameters: engineCode,
        },
        headers: {
            EngineCode: engineCode,
        },
    });
}
